import { useNavigate } from "react-router-dom";

const Step2 = () => {
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <>
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Check your email to reset your password.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Password Reset</div>
                </div>
                <div className="mb-5 px-[30px] flex flex-col space-x-[10x] w-full">
                  <p className="text-xl font-normal mt-[10px] mb-[10px]">
                    Tap the <strong>link sent to your email </strong> to reset the password.
                  </p>
                  <p className="text-xl font-normal mt-[10px] mb-[10px]">For security, the link expires in 24 hours.</p>
                </div>
                <div className="flex justify-center w-full px-[30px] mb-[30px]"></div>
                <div className="thickseparator"></div>
                <div className="flex flex-col items-center justify-between w-full p-[30px]">
                  <p className="text-xl font-normal mt-[10px] mb-[10px] cursor-pointer" onClick={handleSubmit}>
                    <strong> Log In with a different email? </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step2;
